import ScrollMagic from 'scrollmagic';

export function scrollMagic() {
  const controller = new ScrollMagic.Controller();
  const controllerPageTop = new ScrollMagic.Controller();

  const fadeIn = document.querySelectorAll('.js-scrollTrigger');
  const fadeInPageTop = document.querySelectorAll('.js-footerPos');

  for (let i = 0; i < fadeIn.length; i++) {
    const tag = fadeIn[i];

    new ScrollMagic.Scene({
      triggerElement: tag,
      triggerHook: 'onEnter',
      offset: 20,
    })
      .setClassToggle(tag, 'is-animated')
      .addTo(controller);
  }

  for (let i = 0; i < fadeInPageTop.length; i++) {
    const tag = fadeInPageTop[i];

    new ScrollMagic.Scene({
      triggerElement: tag,
      triggerHook: 'onEnter',
      offset: 20,
    })
      .setClassToggle(tag, 'is-animated')
      .addTo(controllerPageTop);
  }
}
